import { StatusEnum } from "./status-enum";

export const statusLabels = {
  [StatusEnum.ACTIVE]: "Aktif",
  [StatusEnum.INACTIVE]: "Tidak Aktif",
};
